/** @jsxImportSource @emotion/react */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  fetchPaymentMethodOptions,
  // fetchPaymentStatusOptions,
  fetchProgramOptions,
  fetchBatchOptions,
} from 'helpers';

import Sidebar from 'components/layout/Sidebar/Sidebar';
import {
  FilterSection, FilterField, FilterActions, countActiveFilters,
} from 'components/layout/Sidebar/Filter';
import {
  CustomDatepicker as Datepicker,
  Select2,
  Select,
} from 'components/common';
import {
  filterConditionsContainerStyles,
  datepickerContainerStyles,
  select2ContainerStyles,
  selectContainerStyles,
} from './Sidebar.styles';

const PTPStudentSidebar = ({
  search,
  startDate,
  endDate,
  setDateRange,
  filterCondition,
  handleChange,
  handleSelect2Change,
  handleSubmit,
  handleReset,
  // handleDownloadCSV,
  // isCsvDownloading,
}) => {
  const [programOptions, setProgramOptions] = useState([]);
  const [batchOptions, setBatchOptions] = useState([]);
  // const [paymentStatusOptions, setPaymentStatusOptions] = useState([]);
  const [paymentMethodOptions, setPaymentMethodOptions] = useState([]);

  useEffect(() => {
    fetchBatchOptions(false)
      .then((data) => {
        setBatchOptions(data);
      });
  }, []);

  // useEffect(() => {
  //   fetchPaymentStatusOptions()
  //     .then((data) => {
  //       setPaymentStatusOptions(data);
  //     });
  // }, []);

  useEffect(() => {
    fetchProgramOptions('PART_TIME')
      .then((data) => {
        setProgramOptions(data);
      });
  }, []);

  useEffect(() => {
    fetchPaymentMethodOptions()
      .then((data) => {
        setPaymentMethodOptions(data);
      });
  }, []);

  return (
    <Sidebar search={search} activeCount={countActiveFilters(filterCondition, startDate)}>
      <div css={filterConditionsContainerStyles}>
        <FilterSection title="Dates">
          <FilterField label="date range">
            <Datepicker
              portalId="filter-panel-popover"
              containerStyles={datepickerContainerStyles}
              startDate={startDate}
              endDate={endDate}
              setDateRange={setDateRange}
              placeholder="date range"
            />
          </FilterField>
        </FilterSection>
        <FilterSection title="Program">
          <FilterField label="program">
            <Select
              containerStyles={selectContainerStyles}
              name="enrolledProgramCode"
              options={programOptions}
              placeholder="program"
              value={filterCondition.enrolledProgramCode}
              onChange={handleChange}
            />
          </FilterField>
          <FilterField label="registered batch">
            <Select2
              portalMenu
              containerStyles={select2ContainerStyles}
              defaultValue={{ label: 'registered batch', value: '' }}
              options={batchOptions}
              placeholder="registered batch"
              onChange={(e) => handleSelect2Change(e, 'appliedBatch')}
              value={filterCondition.appliedBatch}
            />
          </FilterField>
          <FilterField label="enrolled batch">
            <Select2
              portalMenu
              containerStyles={select2ContainerStyles}
              defaultValue={{ label: 'enrolled batch', value: '' }}
              options={batchOptions}
              placeholder="enrolled batch"
              onChange={(e) => handleSelect2Change(e, 'enrolledBatch')}
              value={filterCondition.enrolledBatch}
            />
          </FilterField>
        </FilterSection>
        <FilterSection title="Payment">
          <FilterField label="payment option">
            <Select
              containerStyles={selectContainerStyles}
              name="paymentOption"
              options={paymentMethodOptions}
              placeholder="payment option"
              value={filterCondition.paymentOption}
              onChange={handleChange}
            />
          </FilterField>
        </FilterSection>
      </div>
      <FilterActions onApply={handleSubmit} onReset={handleReset} />
    </Sidebar>
  );
};

PTPStudentSidebar.propTypes = {
  search: Sidebar.propTypes.search,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  setDateRange: PropTypes.func.isRequired,
  filterCondition: PropTypes.shape({
    appliedBatch: PropTypes.string,
    enrolledBatch: PropTypes.string,
    application_result: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
    test_result: PropTypes.string,
    enrolledProgramCode: PropTypes.string,
    paymentOption: PropTypes.string,
    paymentStatus: PropTypes.string,
    student_status: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSelect2Change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  // handleDownloadCSV: PropTypes.func.isRequired,
  // isCsvDownloading: PropTypes.bool.isRequired,
};

PTPStudentSidebar.defaultProps = {
  search: null,
  startDate: null,
  endDate: null,
};

export default PTPStudentSidebar;
